import { useEffect } from "react";
 
export const pushToDataLayer = (products: Array<{
    title: string;
    sku: string;
    price: number;
    listType?: string;
}>) => {
    
    // Initialize dataLayer if it doesn't exist
    window.dataLayer = (window as any).dataLayer || [];

    useEffect(() => {
        // This should run only once when the component mounts
        window.dataLayer.push({
            'event': 'view_item_list',
            'ga4': {
                'items': products.map(product => ({
                    'item_id': product.sku,
                    'item_name': product.title,
                    'price': product.price,
                    'item_list_name': product.listType
                }))
            }
        });
    }, []); 
};
 